import {
  Box,
  Button,
  Collapse,
  Flex,
  SlideFade,
  Stack,
  Text,
  Img,
  useColorModeValue,
  Image,
  Input,
} from "@chakra-ui/react";
import { BsBellFill, BsThreeDotsVertical } from "react-icons/bs";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import {
  getBanners,
  getEstateDue,
  getEstateDues,
  getEvent,
  getManagerAnnouncement,
} from "./service";
import { AuthContext } from "../../context/authContext";
import FullPageLoader from "../../components/FullPageLoader";
// import EstateDueCard from "./components/EstateDueCard";
import Container from "../../components/Container";
import Header from "../../components/Header";
import Footer from "../../components/footer";
import { PROTECTED_PATHS } from "../../app/constants";
import SingleNewsCard from "./components/SingleNewsCard";
import HeadSeemore from "../../components/HeadSeemore";
import { CarouselProvider, Slider, Slide } from "pure-react-carousel";
import "pure-react-carousel/dist/react-carousel.es.css";
import { v4 } from "uuid";
import { transition } from "../..";
import { COLORS } from "../../constants/colors";
import hero from "./hero.png";
import { IoMdPersonAdd } from "react-icons/io";
import { UserProfileContext } from "../../context/userProfileContext";
import { getGuests } from "../guest-history/service";
import dayjs from "dayjs";
import { Popover } from "../../components/Popover";
import { getOutstandingBill } from "../billing-analysis/services";
import { getDueTypes } from "../my wallet/service";
import { PrimaryButton } from "../../components/CustomButton";
import { errorNotifier, successNotifier } from "../../components/NotificationHandler";
import axios from "axios"; // Using axios for HTTP request
import http from "../../services/api"; 

const MyEstate = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  



  const { userProfile } = useContext(UserProfileContext);
  const navigate = useNavigate();
  const pageBg = useColorModeValue(COLORS.bgGrey, COLORS.darkModeBg);
  const transBg = useColorModeValue(COLORS.green, COLORS.chartbg);
  const cardBg = useColorModeValue(COLORS.primary, COLORS.white);
  const heroBg = useColorModeValue(COLORS.primary, COLORS.black);
  const pendCardBg = useColorModeValue(COLORS.white, COLORS.white);
  const pendTextBg = useColorModeValue(COLORS.white, COLORS.green);
  const appTextColor = useColorModeValue(COLORS.white, COLORS.grey);
  const [estateDue, setEstateDue] = useState([]);
  const [estateDues, setEstateDues] = useState([]);
  const [events, setEvents] = useState([]);
  const [guests, setGuests] = useState([]);
  const [banners, setBanners] = useState([]);
  const [outstandingBills, setOutstandingBills] = useState([]);
  const [dueTypes, setDueTypes] = useState([]);
  const { userInfo } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const { userId } = userInfo;
  const [announcements, setAnnouncements] = useState([]);
  const { INVITE_GUEST, ESTATE_BILLS, GUEST_LIST } = PROTECTED_PATHS;
  const inputStyle = {
    bg: "white",
    rounded: "lg",
    color: "#262636",
  };

  const handleSubmit = async () => {
    if (!email) {
      setError("Email address is required.");
      return;
    }

      // Check if the email format is valid
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    setError("Please enter a valid email address.");
    return;
  }
  
    // Clear error if validation passes
    setError("");
    // Handle the form submission logic here (e.g., send the email somewhere)
    console.log("Email submitted:", email);

    const payload = { email };

    try {
      // Inline API call
      const response = await http.post('/card/verify-resident', payload); // This will use the base URL from api.js

      const result = response.data?.result;

      console.log(response.data);
      
      // Display success notification
      successNotifier(result?.message);

      console.log("Redirecting to IdCard page with state:", result?.data);

      // Redirect to IdCard page
      navigate(PROTECTED_PATHS.ID_CARD, { state: result });
    } catch (error) {
      // Error handling
      console.error("Error submitting email:", error);

      const errorMessage = error.response?.data?.message || error.response?.data?.result?.message || "An unknown error occurred.";
      errorNotifier(errorMessage);
      
    } finally {
      setLoading(false); // Hide loading state
    }
  };

  useEffect(() => {
    getEstateDue(userId, setEstateDue, setLoading);
    getEstateDues(setLoading, setEstateDues, userId);
    getEvent(userId, setLoading, setEvents);
    getManagerAnnouncement(setLoading, userId, setAnnouncements);
    getGuests(userId, setLoading, setGuests);
    getBanners(setLoading, userId, setBanners);
    getOutstandingBill(userId, setLoading, setOutstandingBills);
    getDueTypes(userId, setLoading, setDueTypes);
  }, [userId]);

  console.log(outstandingBills, "estateDue:", estateDue);
  console.log("DueTypes", dueTypes);

  return loading ? (
    <FullPageLoader />
  ) : (
    <SlideFade in={true} offsetY="500px" {...transition}>
      <Stack pb="15vh" w={"100%"} overflowX={"hidden"}>
        <Stack bg={pageBg} my="20px">
          <Container>
            <Header menu />
          </Container>
        </Stack>
        <Container>
          <Box>
            {banners.length > 0 ? (
              <CarouselProvider
                infinite={true}
                visibleSlides={1}
                dragEnabled={false}
                isPlaying={true}
                naturalSlideWidth={120}
                naturalSlideHeight={55}
                totalSlides={banners?.length}
              >
                <Slider>
                  {banners &&
                    banners?.map((b) => (
                      <Slide key={v4()}>
                        <Img {...flasSaleImageStyles} src={b?.imageUrl} />
                      </Slide>
                    ))}
                </Slider>
              </CarouselProvider>
            ) : (
              <Flex bg={COLORS.lightGreen} borderRadius="10px">
                <Flex>
                  <Text
                    fontSize="20px"
                    maxW={"65%"}
                    p="20px"
                    fontWeight="600"
                    color={heroBg}
                  >
                    Good Estate Management Happy Family
                  </Text>
                  <Img w="40%" rounded="lg" src={hero} alt="Hero image" />
                </Flex>
              </Flex>
            )}
          </Box>
        </Container>
        <Container>
      <Stack spacing={4}> {/* Adjust spacing as needed */}
        <Text fontSize="2xl" fontWeight="bold">
          Welcome to Lekki Garden 4
        </Text>
        <Text fontSize="md">Please input your email address to proceed</Text>

        <Box>
          
          <Input
            {...inputStyle}
            type="email"
            placeholder="tenant@gmail.com"
            name="email"
            _placeholder={{ opacity: 1, color: "black" }}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {error && <Text color="red.500" fontSize="sm">{error}</Text>} {/* Display error message */}

        </Box>

        <PrimaryButton
          size="md"
          onClick={handleSubmit}
          btnText="Submit"
          buttonProps={{ px: "1px" }}
        />
      </Stack>
    </Container>

      </Stack>
    </SlideFade>
  );
};

export default MyEstate;


const flasSaleImageStyles = {
  w: "100%",
  h: "150px",
  objectFit: "cover",
  borderRadius: "10px",
  alt: "flash sales",
};


